import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/base/SEO';
import Hero from './components/Hero';
import CategoryShowcase from './components/CategoryShowcase';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  const pageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '韩国伦理文化研究 - 首页',
    description: '全面了解韩国伦理的核心内涵，涵盖儒家伦理传统、现代韩国伦理观念演变、家庭与社会伦理规范。',
    url: window.location.href,
    isPartOf: {
      '@type': 'WebSite',
      name: '韩国伦理文化研究',
      url: 'https://korea-ethics.com/',
    },
  };

  return (
    <>
      <SEO
        title="韩国伦理：深度解析韩国伦理文化与价值观"
        description="全面了解韩国伦理的核心内涵，涵盖儒家伦理传统、现代韩国伦理观念演变、家庭与社会伦理规范，以及韩国伦理在影视、职场、人际关系中的实际体现，帮助你深入理解韩国文化精髓。"
        keywords="韩国伦理,韩国伦理文化,韩国儒家伦理,韩国社会伦理观,韩国家庭伦理,韩国职场伦理规范,韩国伦理与影视文化"
        canonicalUrl="https://korea-ethics.com/"
        schema={pageSchema}
      />

      <Navbar />

      <main>
        <Hero />
        <CategoryShowcase />
        <FeaturedArticles />
        <LatestArticles />
        <FAQSection />

        <section className="py-14 bg-primary-500">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
              开启韩国伦理文化探索之旅
            </h2>
            <p className="text-background-50/80 text-sm md:text-base mb-8 max-w-xl mx-auto">
              无论你是韩国文化爱好者、学术研究者，还是在韩工作生活的华人，这里都有你需要的深度洞察
            </p>
            <a
              href="#categories"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50 text-primary-600 rounded-lg font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              立即探索
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}